export default "__VITE_ASSET__DfBY8AGU__"